import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Loader2, User, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const redirectTo = new URLSearchParams(loc.search).get("redirect") || "/account";

  useEffect(() => {
    if (user) {
      nav(user.role === "admin" ? "/admin" : redirectTo, { replace: true });
    }
  }, [user, nav, redirectTo]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      toast.success(`Welcome back${data.name ? ", " + data.name.split(" ")[0] : ""}!`);
      nav(data.role === "admin" ? "/admin" : redirectTo, { replace: true });
    } catch {
      toast.error("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="login-page" className="container-x py-16 md:py-24">
      <div className="max-w-md mx-auto">
        <div className="w-14 h-14 bg-[#EC008C] text-white flex items-center justify-center mb-6 rounded-full">
          <User size={22} />
        </div>
        <div className="text-[11px] tracking-[0.28em] uppercase text-[#EC008C] font-semibold mb-3">Account</div>
        <h1 className="font-display font-light text-4xl md:text-5xl text-black tracking-tight">
          Sign <span className="font-black">in.</span>
        </h1>
        <p className="mt-3 text-[#4A4A4A] font-light">Track your orders, save your favorites, and check out faster.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-[10px] tracking-[0.28em] uppercase font-semibold text-black mb-2 block">Email</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-black focus:outline-none focus:border-[#EC008C]"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.28em] uppercase font-semibold text-black mb-2 block">Password</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-black focus:outline-none focus:border-[#EC008C]"
            />
          </div>
          <button data-testid="login-submit" disabled={loading} className="w-full btn-primary justify-center disabled:opacity-60">
            {loading ? <Loader2 size={16} className="animate-spin" /> : <>Sign in <ArrowRight size={14} /></>}
          </button>
        </form>

        <div className="mt-8 border-t border-[#E5E2DA] pt-8 text-center">
          <p className="text-sm text-[#4A4A4A] font-light">New to MAKEBA?</p>
          <Link to="/register" data-testid="link-register" className="mt-2 inline-block btn-outline">
            Create an account
          </Link>
        </div>
      </div>
    </main>
  );
};

export default Login;
